<template>
<section class="content">
    <div  class="container-fluid">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
                <div class="card-header">
                    <h2 class="card-title " style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Announcement</h2>
                </div>
                <div class="info-box" style="background-image: url('images/heading.jpg');background-size: cover;background-repeat: no-repeat;">
                    <div class="table-responsive" >
                        <table class="table m-0 table table-bordered table-striped">
                            <thead class="bg-info border border-info">
                                <tr>
                                    <th>SlNo</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Title</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Description</th>
                                </tr>
                            </thead>
                            <tbody class="bg-secondary">
                                <tr v-for="(item, index) in announcementList" :key="index">
                                    <td><span>{{ index + 1 }}</span></td>
                                    <td><span class="badge badge-warning">{{ item.title }}</span></td>
                                    <td>
                                        <small v-html="formatDescription(item.description)"></small>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody id="annoucement"  style='display: none'>
                            <tr>
                                <td><span class="badge badge-warning">1</span> </td>
                                <td><span class="badge badge-warning">No Information</span> </td>
                                <td><span class="badge badge-warning">No Information</span></td>
                                
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" >
            <div class="col-md-8">
                <div class="card" id="title">
                    <div class="card-header">
                        <h2 class="card-title " style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Admission Details</h2>
                    </div>
                <!-- when student login -->
                <div class="card-body p-0" id="student"  style='display: none'>
                    <div class="table-responsive">
                    <table class="table m-0 table table-bordered table-striped">
                        <thead class="bg-info border border-info">
                            <tr>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>No</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Dzongkhag/Thromde</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>School Name</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Admission Class</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>School Decision</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Student Decision</th>
                            </tr>
                        </thead>
                        <tbody class="border border-info">
                            <tr id="record1" v-for='(item, index) in response_data' :key="index">
                                <td><span>{{ index + 1 }}</span> </td>
                                <td>
                                    <span style='font-weight: bold;font-family: "Times New Roman"'>{{dzongkhagArray[item.Dzongkhagid]}}</span>
                                </td>
                                <td>
                                    <span style='font-weight: bold;font-family: "Times New Roman"'>{{item.organization.name}}</span>
                                </td>
                                <td>
                                <span  style='font-weight: bold;font-family: "Times New Roman"'>{{item.class}} <span v-if="item.streamName!='null'">{{item.streamName}}</span></span> 
                                </td>
                                <td><span class="badge badge-success">{{item.school_decision==null ? 'Pending' : item.school_decision}} </span></td>
                                <td><span class="badge badge-success">{{item.student_decision==null ? 'Pending' : item.student_decision}}</span> </td>
                            </tr>
                        </tbody>
                        <tbody id="notupdate"  style='display: none'>
                            <tr>
                                <td><span class="badge badge-warning">EMPTY</span> </td>
                                <td><span class="badge badge-warning">EMPTY</span> </td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <!-- when parent login -->
                <div class="card-body p-0" id="parent" style='display: none'>
                    <div class="table-responsive">
                    <table class="table m-0 table table-bordered table-striped">
                        <thead class="bg-info border border-info">
                            <tr>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>No</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Student Name</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Cid Number</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Date of Birth</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Admission Class</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Date of Admission</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Admission Type</th>
                            </tr>
                        </thead>
                        <tbody class="border border-info">
                            <tr v-for="(std, index) in stdList" :key="index">
                                <td><span class="badge badge-success" >{{ index + 1 }}</span> </td>
                                <td> <span style='font-weight: bold;font-family: "Times New Roman"'>{{ std.FirstName }} {{ std.MiddleName }} {{ std.LastName}}</span></td>
                                <td> <span style='font-weight: bold;font-family: "Times New Roman"'>{{ std.CidNo}}</span></td>
                                <td> <span class="badge badge-success">{{ std.DateOfBirth}}</span></td>
                                <td> <span style='font-weight: bold;font-family: "Times New Roman"'>{{ std.class_id}}</span></td>
                                <td> <span class="badge badge-success">{{ std.DateOfApply}}</span></td>
                                <td> <span style='font-weight: bold;font-family: "Times New Roman"'>{{ std.AdmissionType=='New'? "New Registration":'Old Student'}}</span></td>
                            </tr>
                        </tbody>
                        <tbody id="studentparent"  style='display: none'>
                            <tr>
                                <td><span class="badge badge-warning">EMPTY</span> </td>
                                <td><span class="badge badge-warning">EMPTY</span> </td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                <td><span class="badge badge-warning">EMPTY</span></td>
                                
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
            <div class="col-md-4">
                <div class="info-box mb-3 bg-info" id="inwindow" style='display: none'>
                    <span class="info-box-icon"><i class="far fa-calendar"></i></span>
                    <div class="info-box-content blink-text">
                        <label class="text-white" style='font-weight: italic;font-family: "Times New Roman", Times, serif;text-shadow: 0px 0px #fff;'><i><b>Admission window is opened for Class {{this.from_class}} 
                            to {{this.to_class}} from Date {{this.from_date}} to {{to_date}} [Note that this excludes transfer for current students in Classes VI, VIII, and X],<br> Thank You</b></i></label><br>
                    </div>
                </div>
                    <div class="info-box mb-3 bg-danger" id="outsidewindow"  style='display: none'>
                        <span class="info-box-icon"><i class="far fa-calendar"></i></span>
                            <div class="info-box-content">
                                <label class="text-white" style='font-weight: italic;font-family: "Times New Roman", Times, serif'><i><b>Sorry, Admission window for any classes is closed currently, <br>Thank You</b></i></label><br>
                            </div>
                    </div>
                    <div class="info-box mb-3 bg-secondary">
                        <span class="info-box-icon">  <i class="ion ion-ios-people"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text" style='font-weight: bold;font-family: "Times New Roman'>New Student Admissions (Current Window)</span>
                            <b class="info-box-number">{{this.newCount}}</b>
                        </div>
                    </div>
                    <div class="info-box mb-3 bg-success">
                        <span class="info-box-icon">  <i class="ion ion-ios-people"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text" style='font-weight: bold;font-family: "Times New Roman'>New Student Transfer (Current Window)</span>
                            <b class="info-box-number">{{this.transfer}}</b>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
    export default {
        data(){
            return {
                user_type:'',
                dzongkhagArray:{},
                response_data:[],
                stdList:[],
                streamList:[],
                announcementList:[],
                from_date:'',
                to_date:'',
                from_class:'',
                to_class:'',
                newCount:'',
                transfer:'',
            }
        },
        methods: {
        async getStreamList(){
            let uri = '/organizations/getStreamListForPrivate/'+ science;
            try{
                await axios.get(uri).then(response => {
                    let data= response.data;
                    this.streamList=data;
                    if(data!=null && data!=''){
                        for(let i=0;i<data.length;i++){
                            this.streamList[data[i].id] = data[i].stream;
                        }
                    }
                });
            }catch(e){
                console.log('error '+e);
            }
        },
        formatDescription(description) {
            // Assuming description is a string containing HTML
            // You can customize this method based on your specific needs
                const formattedDescription = description.replace(
                    /(https?:\/\/[^\s]+)/g,
                    '<a href="$1" target="_blank">$1</a>'
                );
                return formattedDescription;
            },
            getdzongkhagList(type){
                let uri ='masters/loadGlobalMasters/all_active_dzongkhag';
                axios.get(uri)
                .then(Response =>{
                    let data = Response.data.data;
                    this.dzongkhagList = data;
                    for(let i=0;i<data.length;i++){
                        this.dzongkhagArray[data[i].id] = data[i].name;
                    }
                    $('#dzongkhag').prop('disabled',false);
                }).catch(error => console.log(error));
            },
            generatePassword(){
                axios.post('admissions/generatePassword').then(res => {
                }).catch(error => console.log(error))
            },
            loadadmissions(id){
                axios.get('/admissions/getorgclassDetails/'+id)
                .then(Response =>{
                    let data = Response.data;
                    if(data!='null' && data!=""){
                        this.response_data=data;
                        $('#notupdate').hide();
                    }
                    else{
                        $('#notupdate').show();
                    }
                   
                }).catch(error => console.log(error));
            },
            loadStudentList(param){
                let uri="";
                    uri='admissions/loadStudentList/'+param;
                    axios.get(uri)
                    .then(response => {
                        let data = response.data.data;
                        if(data!=null && data!=""){
                            this.stdList = data;
                            $('#studentparent').hide();
                        }
                        else{
                            $('#studentparent').show();
                        }
                        
                    });
            },
            AnnouncementListDetails(){
                let uri="";
                    uri='announcementList';
                    axios.get(uri)
                    .then(response => {
                        let data = response.data;
                        if(data!=null && data!=''){
                            this.announcementList = data;
                        }
                        else{
                            $('#annoucement').show();
                        }
                    });
            },
            checkForAdmissionWindow(){
                axios.get('masters/loadGlobalMasters/apply')
                .then(response => {
                    let data = response.data.data;
                    if(data!=null && data!=""){
                        this.from_class = data.from_class;
                        this.to_class = data.to_class;
                        this.from_date = data.from_date;
                        this.to_date = data.to_date;
                        $('#outsidewindow').hide();
                        $('#inwindow').show();
                    }
                    else{
                        $('#outsidewindow').show();
                        $('#inwindow').hide();
                    }
                    this.loadAdmissionCount();
                })
                .catch(errors => {
                    console.log(errors)
                });

            },
            loadAdmissionCount(){
                axios.get('/admissions/loadAdmissionCountForPortal/'+ this.from_date+'/'+this.to_date)
                .then(Response =>{
                    let data = Response.data;
                    if(data.newCount!=null && data.newCount!=""){
                        this.newCount = data.newCount;
                    }
                    else{
                        this.newCount = 0;
                    }
                    if(data.transfer!=null && data.transfer!=""){
                        this.transfer = data.transfer;
                    }
                    else{
                        this.transfer = 0;
                    }
                }).catch(error => console.log(error));
            }

        },
        async mounted() {
            this.AnnouncementListDetails();
            this.checkForAdmissionWindow();
            this.getdzongkhagList();
            axios.get('getSessionDetail')
            .then(response => {
                let data = response.data.data;
                this.std_id=data['std_id'];
                this.id = data['id']
                if(data['user_type'] == 'Parent'){
                    this.loadStudentList(this.id);
                    $('#student').hide();
                    $('#parent').show();
                }
                else if(data['user_type'] == 'Admin'){
                    $('#student').hide();
                    $('#parent').hide();
                    $('#title').hide();
                }
                else{
                    this.loadadmissions(this.std_id);
                    $('#student').show();
                    $('#parent').hide();
                }
                this.getStreamList();
            })
            .catch(errors => {
                console.log(errors)
            });
           
        }
    }
</script>
